import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { gateway_recommendation_type } from "../../enums";
import {
  useAccountSettings,
  useHookForm,
  useMerchantApiMutation,
} from "../../hooks";
import { ISubscriptionAndEmailSettings } from "../../interfaces-and-types";
import { globalHandlerUtils } from "../../utils";
import { subscriptionAndEmailValidationSchema } from "./validationSchema";

import { View } from "./View";

export const SubscriptionAndEmails = () => {
  const navigate = useNavigate();

  const {
    // isLoading: isLoadingAccountSettings,
    isSuccess: isSuccessAccountSettings,
    data: accountSettings,
    refreshRemoteData: refreshAccountSettings,
  } = useAccountSettings();

  useEffect(() => {
    accountSettings && reset(accountSettings);
  }, []);

  useEffect(() => {
    if (isSuccessAccountSettings) {
      accountSettings && reset(accountSettings);
    }
  }, [isSuccessAccountSettings]);

  const initialFormValues: ISubscriptionAndEmailSettings = {
    email_receipt_to_customers: false,
    email_receipt_to_me: false,
    email_receipt_to_team_members: false,
    send_emails_about_renewals: false,
    send_emails_about_expiring_cards: false,
    email_invoices_to_customers: false,
    send_merchant_reminders_for_unpaid_subscriptions: false,
    send_customers_reminders_for_unpaid_subscriptions: false,
    notify_customers_on_failed_payments: false,
    cancel_and_notify_customer_on_failed_retries: false,
    include_current_balance_in_emails: false,

    retry_failed_payments_after_days: 2,
    resend_expired_invoices_after_days: 2,

    // ...accountSettings,
  };

  const { isSuccess: isSuccessSaveSettings, mutate: saveSettings } =
    useMerchantApiMutation<
      ISubscriptionAndEmailSettings,
      ISubscriptionAndEmailSettings
    >("saveSubscriptionAndEmailSettings").usePutMutation;

  const handleApiSubmit = (data: ISubscriptionAndEmailSettings) => {
    saveSettings(data);
  };

  const handleError = (errors: any) => globalHandlerUtils.handleError(errors);

  const { onFormSubmit, isDirty, errors, register, reset } = useHookForm({
    initialFormValues,
    validationSchema: subscriptionAndEmailValidationSchema,
    onValid: handleApiSubmit,
    onInvalid: handleError,
  });

  useEffect(() => {
    if (isSuccessSaveSettings) {
      refreshAccountSettings();
    }
  }, [isSuccessSaveSettings]);

  const goBack = () => navigate("/settings");

  return (
    <View
      goBack={goBack}
      isDirty={isDirty}
      handleSubmit={onFormSubmit}
      register={register}
      errors={errors}
    />
  );
};
